import React from 'react';
import { Box } from '@mui/material';
import { FF_LOGO_SRC } from './assistantStijl';

// Het Full Frame-beeldmerk (zelfde bestand als in de zijbalk) i.p.v. het MUI-robotje.
export default function AssistantAvatar({ size = 28, sx = {} }) {
  return (
    <Box
      component="img"
      src={FF_LOGO_SRC}
      alt="Full Frame"
      data-testid="assistent-avatar"
      sx={{ width: size, height: size, objectFit: 'contain', flexShrink: 0, ...sx }}
    />
  );
}
